module.exports = {"652927100":"乌什镇","652927101":"阿合雅镇","652927102":"依麻木镇","652927200":"阿克托海乡","652927201":"亚科瑞克乡","652927202":"阿恰塔格乡","652927205":"英阿瓦提乡","652927206":"亚曼苏柯尔克孜族乡","652927207":"奥特贝希乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652927.json
// module id = 3098
// module chunks = 0